import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const GENDER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Gender.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Gender.Code')
    .required()
    .maxLength(10)
    .build(),
];

export const GENDER_CONFIG = {
  entityName: 'Gender',
  localizationKey: 'Planning::Entity.Gender',
  fields: GENDER_FIELDS,
  permission: 'PlanningEnvironment.Genders',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
